// extracted by mini-css-extract-plugin
export default {"actions":"AppTableItem_actions__dWSpe","loadingIcon":"AppTableItem_loadingIcon__a5FMK"};